import { useGetBankAccountsList } from '@/hooks/requests/useBankAccounts';
import { BankAccountListSortBy } from '@/types/bankAccounts';
import { Box, Card, Stack, Typography, useMediaQuery } from '@mui/material';
import { formatCurrency } from '@/utils/currency';
import { useNavigate } from 'react-router-dom';
import { SVLoader, SVButton } from '@/components/core';

export default function AdvisorDashboardRecentlyOpenedAccounts() {
  const navigate = useNavigate();
  const isLargeScreen = useMediaQuery(theme => theme.breakpoints.up('lg'));
  const { accounts, accountsIsPending } = useGetBankAccountsList({
    page: 0,
    records_per_page: 5,
    sort_by: BankAccountListSortBy.OPENED_DESCENDING,
  });

  if (accountsIsPending) {
    return (
      <Card>
        <SVLoader />
      </Card>
    );
  }

  if (!accounts || !accounts.length) {
    return null;
  }

  return (
    <Card>
      <Typography variant="h5" mb={2}>
        Recently Opened Accounts
      </Typography>
      <Stack spacing={2}>
        {accounts.map(account => {
          const {
            uuid,
            accountNumberLast4,
            accountTypeStr,
            availableBalance,
            currentBalance,
            primaryOwner,
          } = account;

          return (
            <Card variant="hover" onClick={() => navigate('')} key={uuid}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: isLargeScreen ? 'row' : 'column',
                  justifyContent: 'space-between',
                  gap: 2,
                }}>
                <Box>
                  <Typography variant="body2" fontWeight="bold">
                    [{accountTypeStr}] ...{accountNumberLast4}
                  </Typography>
                  <Typography variant="body2">
                    {primaryOwner.profile.firstName}{' '}
                    {primaryOwner.profile.lastName}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="body2">
                    Avail:{' '}
                    <Typography
                      variant="body2"
                      component="span"
                      fontWeight="bold">
                      {formatCurrency({ amount: availableBalance.value })}
                    </Typography>
                  </Typography>
                  <Typography variant="body2">
                    Curr:{' '}
                    <Typography
                      variant="body2"
                      component="span"
                      fontWeight="bold">
                      {formatCurrency({ amount: currentBalance.value })}
                    </Typography>
                  </Typography>
                </Box>
              </Box>
            </Card>
          );
        })}
      </Stack>
      <SVButton sx={{ mt: 2 }} variant="text" onClick={() => navigate('')}>
        View All
      </SVButton>
    </Card>
  );
}
